
/*
 * Menu
 */

/* global biro_body */


// On page load
jQuery(function($) {

	// Init
	var hmw = $( '.header-menu-wrapper' );

	// Menu controls
	$('.nav-dynamic')
		.on('click', '.top-level-button', function( e ) {

			// Open sub-menu
			var el = $(this);
			var p = el.parents('[aria-expanded]');
			el.toggleClass( 'top-level-button-open' );
			p.attr(
				'aria-expanded',
				p.attr('aria-expanded') == 'true' ? 'false' : 'true'
			);

		});

	// Mobile toggle
	biro_body.on( 'click', '.mobile-menu-toggle', function() {

		var el = $( this );

		if ( el.attr( 'aria-expanded' ) === 'false' ) {

			hmw.removeClass( 'mobile-menu-closed' ).slideDown( 300 );
			el.attr( 'aria-expanded', 'true' );

		} else {

			hmw.slideUp( 300, function() {
				hmw.addClass( 'mobile-menu-closed' );
			});
			el.attr( 'aria-expanded', 'false' ).blur();
		}
	});

});
